import Dashboard from "../Component/Dashboard";
import { connect } from 'react-redux';
import {
  getCollectionDetail, getAddOnCollectionDetail, getCustomerMatrix, getDashboardStat, getCustomerMatrix_v1,
  getAllMessages, getAssignedToMeMessage, getServiceTypeCollection, getAuditTrail, getScheduleService, getFranchiseGroupList
} from "../../../Action";

const mapStateToProps = (state) => {
  const { FranchiseOverview, AllMessages, Dashboard } = state;
  return {
    FranchiseOverview,
    AllMessages,
    Dashboard
  }
}
const actionCreators = {getCollectionDetail, getAddOnCollectionDetail, getDashboardStat, getCustomerMatrix, getCustomerMatrix_v1,
  getAllMessages, getAssignedToMeMessage, getServiceTypeCollection, getAuditTrail, getScheduleService, getFranchiseGroupList
}

export default (connect(mapStateToProps, actionCreators)(Dashboard));